import { HomeSettingPage } from './HomeSettingPage';
export default HomeSettingPage;
